<template>
    <div class="row justify-content-center">
        <transition name="fade" mode="out-in">
            <AppPlaceholder class="col-xl-8" v-if="!profile" key="no-profile"/>
            <div v-else class="col-xl-8" key="profile">
                <div class="row">
                    <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
                        <div class="pl-3">
                            <h4>{{ profile.name }}</h4>
                            <p class="mb-0 text-muted">
                                <small>Created on {{ profile.created_at | date }}</small>
                            </p>
                        </div>
                        <button class="btn btn-primary" @click="save">Save</button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <AppInput :value="profile.first_name"
                                      @change="updateProp($event, 'first_name')"
                                      label="First Name"
                                      field="first_name"
                                      :errors="errors"
                                      class="col-md-6"/>
                            <AppInput :value="profile.last_name"
                                      @change="updateProp($event, 'last_name')"
                                      label="Last Name"
                                      field="last_name"
                                      :errors="errors"
                                      class="col-md-6"/>
                        </div>
                        <div class="row">
                            <AppInput :value="profile.email"
                                      @change="updateProp($event, 'email')"
                                      label="Email"
                                      field="email"
                                      :errors="errors"
                                      class="col-md-5"/>
                            <AppInput :value="profile.phone"
                                      @change="updateProp($event, 'phone')"
                                      label="Phone"
                                      field="phone"
                                      :errors="errors"
                                      class="col-md-5"/>
                        </div>
                        <div class="row">
                            <AppInput :value="profile.password"
                                      @change="updateProp($event, 'password')"
                                      label="New password"
                                      field="password"
                                      type="password"
                                      :errors="errors"
                                      class="col-md-5"/>
                            <AppInput :value="profile.password_confirmation"
                                      @change="updateProp($event, 'password_confirmation')"
                                      label="Confirm password"
                                      field="password_confirmation"
                                      type="password"
                                      :errors="errors"
                                      class="col-md-5"/>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import NotificationService from '../services/notification.service';
import Errors from '../utils/errors';
import AppInput from './form/AppInput';
import AppPlaceholder from './form/AppPlaceholder';
import { formatDate } from '../filters/date.filter';

export default {
  components: {
    AppInput,
    AppPlaceholder,
  },
  filters: {
    date: formatDate,
  },
  data() {
    return {
      errors: new Errors(),
    };
  },
  computed: {
    ...mapState({
      profile: (state) => state.profile.profile,
    }),
  },
  methods: {
    updateProp(newVal, field) {
      this.errors.clear();

      this.$store.commit('profile/profileProp', {
        newVal,
        field,
      });
    },
    save() {
      this.$store.dispatch('profile/updateProfile')
        .then((res) => {
          NotificationService.success(res.message);
        })
        .catch((err) => this.errors.set(err.response.data.errors));
    },
  },
};
</script>
